module.exports = __webpack_public_path__ + "static/assets/4b2e5261b766c1e489ce654dc671c85d.svg";